import UIkit from 'uikit';

export default {
  notify(message, options = {}) {
    let fullMessage = message;
    if (options.icon) {
      fullMessage = `<span uk-icon="${options.icon}"></span> ${fullMessage}`;
    }
    const status = options.type || 'primary';
    const timeout = options.timeout || 3000;
    const pos = options.pos || 'bottom-center';
    return UIkit.notification({
      message: fullMessage,
      pos,
      status,
      timeout,
    });
  },

  success(message, options = {}) {
    options = Object.assign({ type: 'success', icon: 'check' }, options);
    return this.notify(message, options);
  },

  error(message, options = {}) {
    options = Object.assign({ type: 'danger', icon: 'bolt' }, options);
    return this.notify(message, options);
  },

  warn(message, options = {}) {
    options = Object.assign({ type: 'warning', icon: 'warning' }, options);
    return this.notify(message, options);
  },
};



// WEBPACK FOOTER //
// ./helpers/Toast.js